export const ErrorIcon = () => {
  return (
    <svg fill="none" height="72" viewBox="0 0 72 72" width="72" xmlns="http://www.w3.org/2000/svg">
      <path
        clipRule="evenodd"
        d="M14.3213 60.9994C8.88664 60.9994 5.52493 55.0761 8.31151 50.4102L29.9896 14.112C32.7056 9.56423 39.2932 9.56424 42.0092 14.112L63.6873 50.4102C66.4739 55.0761 63.1121 60.9994 57.6775 60.9994L14.3213 60.9994ZM10.0286 51.4356C8.03818 54.7684 10.4394 58.9994 14.3213 58.9994L57.6775 58.9994C61.5594 58.9994 63.9606 54.7684 61.9702 51.4356L40.2921 15.1375C38.3521 11.8891 33.6467 11.8891 31.7067 15.1375L10.0286 51.4356Z"
        fill="#6E6F73"
        fillRule="evenodd"
      />
      <path
        d="M35.9994 50.9993C35.5869 50.9993 35.2338 50.8525 34.94 50.5587C34.6463 50.265 34.4994 49.9118 34.4994 49.4993C34.4994 49.0868 34.6463 48.7337 34.94 48.44C35.2338 48.1462 35.5869 47.9994 35.9994 47.9994C36.4119 47.9994 36.765 48.1462 37.0588 48.44C37.3525 48.7337 37.4994 49.0868 37.4994 49.4993C37.4994 49.9118 37.3525 50.265 37.0588 50.5587C36.765 50.8525 36.4119 50.9993 35.9994 50.9993Z"
        fill="#6E6F73"
      />
      <path
        clipRule="evenodd"
        d="M35.9994 25.9994C36.5517 25.9994 36.9994 26.4471 36.9994 26.9994L36.9994 43.9994C36.9994 44.5516 36.5517 44.9994 35.9994 44.9994C35.4471 44.9994 34.9994 44.5516 34.9994 43.9994L34.9994 26.9994C34.9994 26.4471 35.4471 25.9994 35.9994 25.9994Z"
        fill="#6E6F73"
        fillRule="evenodd"
      />
    </svg>
  );
};
